import React, { useState, useEffect } from 'react';
import Axios from "axios";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link, useNavigate } from 'react-router-dom';
import { jobDetailsEmailTemplate, SendJobDetailstoInternalLinkedinCandidates } from '../apiconstants/constants';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import { faCheck, faTimes, faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
const SelectedInternalCandidatesList = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const storedCandidates = JSON.parse(localStorage.getItem('SelectedInternalCandidates') || '[]');
  const jobPlainText = localStorage.getItem("jobDescription");
  const jobTitle = localStorage.getItem('title');
  const jobType = localStorage.getItem('jobType');
  const jobPostID = localStorage.getItem('jobPostID');
  const location = localStorage.getItem('location');
  const endClient = localStorage.getItem('endClient');
  const guid = localStorage.getItem('guid');
  const [isLoading, setIsLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editedEmail, setEditedEmail] = useState("");
const { reset, handleSubmit, control, getValues, formState: { errors, isSubmitting }, setValue,register } = useForm();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedCCEmail, setSelectedCCEmail] = useState("");
const [editingEmailMap, setEditingEmailMap] = useState({});
const [editedEmailMap, setEditedEmailMap] = useState({});
const [showPreview, setShowPreview] = useState(false);
const [previewHtml, setPreviewHtml] = useState("");
const email = localStorage.getItem("email")
const mobileNumber = localStorage.getItem("mobileNumber")
const token = localStorage.getItem("jwtToken");
  useEffect(() => {
    if (storedCandidates) {
      setSelectedCandidates(storedCandidates);
    }
    if (jobPlainText) {
      setValue("content", jobPlainText);
    }
  }, []);

 const handleEditClick = (email, currentEmail) => {
  setEditingEmailMap(prev => ({ ...prev, [email]: true }));
  setEditedEmailMap(prev => ({ ...prev, [email]: currentEmail }));
};

const handleSaveClick = (email) => {
  const updatedCandidates = selectedCandidates.map(candidate =>
    candidate.email === email
      ? { ...candidate, email: editedEmailMap[email] }
      : candidate
  );
  setSelectedCandidates(updatedCandidates);
  // localStorage.setItem("SelectedLinkedinCandidates", JSON.stringify(updatedCandidates));
  setEditingEmailMap(prev => ({ ...prev, [email]: false }));
};

const handlePreview = () => {
  if (!showPreview) {
    if (selectedCandidates.length === 0) {
      Swal.fire("No Candidates", "Please select at least one candidate to preview.", "info");
      return;
    }

    const candidate = selectedCandidates[0];
    const values = getValues(); // Gets job description from the form

    const html = jobDetailsEmailTemplate({
      candidateName: candidate.fullName,
      jobTitle: jobTitle || "",
      location: location || "",
      jobType: jobType || "",
      jobDescription: values.content || "",
      candidateMobileNumber:mobileNumber,
      senderEmail:email,
      endClientName:endClient
    });

    setPreviewHtml(html);
    setShowPreview(true);
  } else {
    setShowPreview(false);
  }
};


  const onSubmit = async (data, e) => {
    e.preventDefault();
    reset();
    setIsLoading(true);
const jobDescriptionFromEditor = data.content; // ✅ this is the updated value from WYSIWYG
console.log("61",jobTitle,location,jobType)
    const candidatePayload = selectedCandidates.map(candidate => ({
      candidateName: candidate.fullName,
      candidateEmail: candidate.email,
      senderEmail:email,
      phoneNumber:mobileNumber,
      jobTitle: jobTitle || "",
      location: location || "",
      jobType: jobType || "",
      jobDescription: jobDescriptionFromEditor || "",
      cc: "",
      endClientName: endClient,
      guid:guid,
      jobPostID:jobPostID
    }));

    try {
      const result = await Axios.post(SendJobDetailstoInternalLinkedinCandidates.APIURL, candidatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setIsLoading(false);

      if (Array.isArray(result.data)) {
        const statusListHTML = result.data
          .map(item => `<li><b>${item.email}</b>: ${item.status}</li>`)
          .join("");

        Swal.fire({
          icon: "success",
          title: "Email Status",
          html: `<ul style="text-align: left; padding-left: 20px;">${statusListHTML}</ul>`,
          confirmButtonText: "OK",
          width: 600
        });

        navigate("/Employer/ViewMatchedInternalCandidates");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Add correct Details",
          showConfirmButton: false,
          timer: 5000
        });
      }
    } catch (error) {
      console.error("Error sending email", error);
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Failed to send emails. Please try again later."
      });
    }
  };

  return (
    <ConsultantLayout>
      {isLoading ? (
        <center><LoadingSpinner /></center>
      ) : (
        <div className='container-fluid mt-3'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ViewMatchedInternalCandidates">
              <i
                className="fa fa-arrow-left"
                style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }}
                aria-hidden="true"
              ></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>
              Selected Candidates List
            </h2>
          </div>

          <table className="table mt-3">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {selectedCandidates.map(item => (
                <tr key={item.guid}>
                  <td>{item.fullName}</td>
        <td>
  {editingEmailMap[item.email] ? (
    <>
      <input
        type="text"
        value={editedEmailMap[item.email] || ""}
        onChange={(e) =>
          setEditedEmailMap(prev => ({
            ...prev,
            [item.email]: e.target.value
          }))
        }
        style={{ width: 400 }}
      />
      <button
        type="button"
        onClick={() => handleSaveClick(item.email)}
        style={{ background: "none", border: "none", marginLeft: 8 }}
      >
        <FontAwesomeIcon icon={faCheck} style={{ color: "green", fontSize: 16 }} />
      </button>
      <button
        type="button"
        onClick={() => setEditingEmailMap(prev => ({ ...prev, [item.email]: false }))}
        style={{ background: "none", border: "none", marginLeft: 8 }}
      >
        <FontAwesomeIcon icon={faTimes} style={{ color: "red", fontSize: 16 }} />
      </button>
    </>
  ) : (
    <>
      {item.email}
      <FontAwesomeIcon
        icon={faPencil}
        onClick={() => handleEditClick(item.email, item.email)}
        style={{ color: "#00a7ac", fontSize: 16, marginLeft: 8, cursor: "pointer" }}
      />
    </>
  )}
</td>

                </tr>
              ))}
            </tbody>
          </table>
 {/* <input
                                            type="text"
                                            {...register("emailCC")}
                                            className={`form-control basic-form mt-3`}
                                            placeholder="CC Email"
                                            value={selectedCCEmail}
                                            onChange={e=>setSelectedCCEmail(e.target.value)}
                                        /> */}

                                       
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
            <div>
               <OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>From Email</Tooltip>
  )}
>
  <input
    type="email"
    {...register("clientemail", { required: "From Email is required" })}
    placeholder="From Email"
    defaultValue={email}
    className={`form-control basic-form mt-3 ${errors.clientemail ? 'is-invalid' : ''}` }
  />
</OverlayTrigger>
              <label style={{ color: "#00a7ac", marginTop: 10 }}>Job Description</label>
              <Controller
                control={control}
                name="content"
                rules={{
                  required: { value: true, message: "Content Required" },
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div>
                    <WYSIWYGEditor
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      inputExtraProps={{
                        required: true,
                      }}
                    />
                    {errors.content && (
                      <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                        {errors.content.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="d-flex justify-content-end mt-5">
               <button
    type="button"
    className="btn btn-primary mr-2"
    onClick={handlePreview}
    style={{ marginRight: 10 }}
  >
    {showPreview ? "Hide Preview" : "Preview Email"}
  </button>
             
              <button
                id="svbutton"
                disabled={isSubmitting || isDisabled}
                className="btn btn-primary mr-2"
              >
                Send Email
              </button>
  <Link to="/Employer/ViewMatchedLinkedinCandidates">
                <button className="btn btn-secondary mr-3">Cancel</button>
              </Link>

            </div>
          </form>
          {showPreview && (
  <div className="mt-4" style={{ border: "1px solid #ccc", padding: "20px", borderRadius: "8px" }}>
    <h5 style={{ color: "#00a7ac" }}>Email Preview</h5>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>
)}

        </div>
      )}
    </ConsultantLayout>
  );
};

export default SelectedInternalCandidatesList;
